import commonDataAccess from "../commonDataAccess";
import { IFilter } from "../../@redux/listRedux";
import { formatFilterForQueryParam } from "../../common/service";

class OrganizationDataAccess {
  getList = (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = formatFilterForQueryParam(params.filters);
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };
    return commonDataAccess.getData("organization/getall", parameters);
  };
  getOrganizationInfo = (id: any) => {
    return commonDataAccess.getData(`organization/get/organization/${id}`);
  };
  saveOrganization = (payload: any) => {
    return commonDataAccess.postData("organization/save/organization", payload);
  };
  getMenuGroupPermissions = (organizationId: any) => {
    return commonDataAccess.getData(
      `organization/get/menuGroupPermissions/${organizationId}`
    );
  };
  saveMenuGroupPermissions = (organizationId: any, menuGroups: string[]) => {
    return commonDataAccess.postData("organization/save/menuGroupPermissions", {
      organizationId: organizationId,
      menuGroups: menuGroups,
    });
  };
  checkDuplicateOrganization =(name: string, id: any = 0) => {
    return commonDataAccess.getData("organization/check/duplicate", {
      name: name,
      id: id,
    });
  };
  deleteOrganization =(organizationIds: string) => {
    return commonDataAccess
      .deleteData(`organization/delete/${organizationIds}`)
      .then((res) => {
        // deleteData resolves with the Error instead of rejecting
        if (res instanceof Error) throw res;
        return res;
      });
  };
  getOrganizationDropdownList =() => {
    return commonDataAccess.getData("organization/get/organizationSelectList");
  };
  switchOrganization = (organizationId: any) => {
    return commonDataAccess.getData(`organization/switch/${organizationId}`);
  };
  getCurrentOrganizationName = () => {
    return commonDataAccess.getData("organization/get/organizationName");
  };
}

export default new OrganizationDataAccess();
